if (!customElements.get('aplovio-pickup')) {
  customElements.define('aplovio-pickup', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.content = this.querySelector('[data-pickup-content]');
      this.pickupSlot = this.querySelector('[data-pickup-slot]');
      this.openButton = this.querySelector('[data-pickup-open]');
      this.loading = this.querySelector('[data-pickup-loading]');
      this.error = this.querySelector('[data-pickup-error]');
      this.empty = this.querySelector('[data-pickup-empty]');
      this.layer = this.querySelector('aplovio-layer');
      this.current = this.content.querySelector('[data-pickup-response]')?.dataset.variantId || '';
      this.apply(this.content.querySelector('[data-pickup-response]'));
      const options = {signal: this.abort.signal};
      const update = event => {
        const local = this.closest('aplovio-product');
        const owner = event?.target || local || [...document.querySelectorAll('aplovio-product')].find(node => node.dataset.productGid === this.dataset.productGid && !node.closest('dialog'));
        if (!owner || owner.dataset.productGid !== this.dataset.productGid || local && local !== owner) return;
        if (!local && owner.closest('dialog')) return;
        const variant = owner.variant?.value;
        if (variant !== undefined && variant !== this.current) this.load(variant);
      };
      document.addEventListener('aplovio:product-ready', update, options);
      document.addEventListener('aplovio:product-state', update, options);
      this.querySelector('[data-pickup-retry]').addEventListener('click', () => this.load(this.current, true), options);
      queueMicrotask(() => {if (this.isConnected) update();});
    }
    apply(response) {
      const locations = response?.querySelector('[data-pickup-locations]');
      const available = Boolean(response?.querySelector('[data-pickup-summary]'));
      this.pickupSlot.replaceChildren();
      if (locations) {locations.hidden = false; this.pickupSlot.append(locations);}
      this.openButton.hidden = !available;
      this.hidden = !available && !this.hasAttribute('data-design-mode');
      if (this.empty) this.empty.hidden = available;
    }
    async load(variant, retry = false) {
      if (!retry && this.current === variant) return;
      this.current = variant;
      this.request?.abort();
      this.request = null;
      const dialog = this.layer?.querySelector('dialog');
      if (dialog?.open) window.AplovioLayers.close(dialog, 'disconnect', true);
      this.error.hidden = true;
      this.openButton.hidden = true;
      this.content.hidden = true;
      this.pickupSlot.replaceChildren();
      if (!/^\d+$/.test(variant || '')) {
        this.hidden = !this.hasAttribute('data-design-mode');
        this.loading.hidden = true;
        this.removeAttribute('aria-busy');
        return;
      }
      const request = new AbortController();
      this.request = request;
      this.hidden = false;
      this.loading.hidden = false;
      if (this.empty) this.empty.hidden = true;
      this.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(`${(this.dataset.root || '/').replace(/\/?$/, '/')}variants/${variant}/`, location.origin);
        url.searchParams.set('section_id', 'aplovio-pickup-availability');
        const result = await window.AplovioLazy.read(url, {signal: request.signal, credentials: 'same-origin'});
        if (!result.ok) throw new Error('Pickup request failed');
        const html = await result.text();
        if (!this.isConnected || this.request !== request) return;
        const response = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pickup-response]');
        if (!response || response.dataset.variantId !== variant) throw new Error('Pickup response did not match the selected variant');
        this.content.replaceChildren(response);
        this.apply(response);
        this.content.hidden = false;
      } catch (error) {
        if (request.signal.aborted || !this.isConnected || this.request !== request) return;
        this.error.hidden = false;
        console.warn('[Aplovio] Pickup availability could not be loaded. Retry is available.');
      } finally {
        if (this.request === request) {
          this.request = null;
          this.loading.hidden = true;
          this.removeAttribute('aria-busy');
        }
      }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.request?.abort(); this.request = null;
      const dialog = this.layer?.querySelector('dialog');
      if (dialog) window.AplovioLayers?.dispose(dialog);
      // Reconnect must retain the initial location content that was moved into the layer.
      const locations = this.pickupSlot?.querySelector('[data-pickup-locations]');
      const response = this.content?.querySelector('[data-pickup-response]');
      if (locations && response) {locations.hidden = true; response.append(locations);}
    }
  });
}
